import React from 'react';
import { useAddPositionMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { AddPositionDto, ProjectDto } from '@/core';
import { RolesAndRatesForm } from './RolesAndRatesForm';
import { FormValueType } from './hooks';

const getInitialValue = (): FormValueType => ({
  name: '',
  rate: null,
});

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsAddRolesForm = ({ projectData }: PropsType) => {
  const form = useAppFindFormik('add-role');
  const [addPosition] = useAddPositionMutation();
  const initialValue = getInitialValue();

  const handleSubmit = (positionData: AddPositionDto) => {
    addPosition({ positionData, projectId: projectData.id })
      .unwrap()
      .then(() => form.current?.resetForm());
  };

  return (
    <RolesAndRatesForm
      handleSubmit={handleSubmit}
      formUid="add-role"
      projectData={projectData}
      initialValue={initialValue}
    />
  );
};
